import React, {Component} from 'react';
import Field from '../Field';
import validator from 'validator';
import PropTypes from 'prop-types';

class CompetitionForm extends Component {
  constructor (props) {
    super(props);
    this.state = {
      fields: {
        name: '',
        email: '',
        message: this.setMessage('Level 1 BSL Training'),
        subject: ''
      },
      fieldErrors: {}
    };
    // required so 'this' is defined in the methods
    this.onInputChange = this.onInputChange.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.setMessage = this.setMessage.bind(this);
    this.validate = this.validate.bind(this);
  }

  setMessage (courseTitle) {
    return 'Chosen course: ' + courseTitle;
  }

  onInputChange (input) {
    const fields = this.state.fields;
    const fieldErrors = this.state.fieldErrors;
    fields[input.name] = input.value;
    fieldErrors[input.name] = input.error;
    fields.subject = 'Competition entry: ' + fields.name;
    this.setState({ fields, fieldErrors });
  }

  onSelectChange (event) {
    const fields = this.state.fields;
    const fieldErrors = this.state.fieldErrors;
    fields.message = this.setMessage(event.target.value);
    this.setState({ fields, fieldErrors });
    console.log(this.state);
  }

  validate () {
    const customer = this.state.fields;
    const fieldErrors = this.state.fieldErrors;
    const errMessages = Object.keys(fieldErrors).filter((k) => fieldErrors[k]);
    if (!customer.name) return false;
    if (!customer.email) return false;
    if (errMessages.length) return false;
    return true;
  }

  handleSubmit (event) {
    event.preventDefault();
    if (this.validate()) {
      this.props.onSubmitClick(this.state.fields);
    }
  }

  render () {
    return (
      <div className='l-container'>
        <h1 className='u-text-center'>Use the form below to enter the competition</h1>
        <div className='l-container l-container--x-narrow'>
          <form noValidate onSubmit={this.handleSubmit}
            className='island island--dark'>
            <ul className='form-fields'>
              <li>
                <label>Name</label>
                <Field
                  name='name'
                  type='text'
                  value={this.state.fields.name}
                  onChange={this.onInputChange}
                  validate={(val) => (val ? false : 'Name Required')}
                />
              </li>
              <li>
                <label>Email</label>
                <Field
                  name='email'
                  type='email'
                  value={this.state.fields.email}
                  onChange={this.onInputChange}
                  validate={(val) => (validator.isEmail(val) ? false : 'Invalid Email')}
                />
              </li>
              <li>
                <label>Course</label>
                <select onChange={this.onSelectChange}>
                  <option>Level 1 BSL Training</option>
                  <option>Level 2 BSL Training</option>
                  <option>Level 3 BSL Training</option>
                  <option>Level 6 BSL Training</option>
                </select>
              </li>
              <li className='form__actions'>
                <button className='button button--shadow disabled' type='submit' disabled={!this.validate()}>Enter competition</button>
                <span style={{marginLeft: 20}}>{this.state.successMessage}</span>
              </li>
            </ul>
          </form>
        </div>
      </div>
    );
  }
}

CompetitionForm.propTypes = {
  onSubmitClick: PropTypes.func
};

export default CompetitionForm;



// WEBPACK FOOTER //
// ./src/components/CompetitionForm/index.js